<template>
    <gz-auth-view-template v-if="$store.getters['staffUserview'].attributes">
        <GZ-PageTitle 
            :title="
                $route.params.id === $store.getters['authUserId'] ? 
                    'Ваш профиль' : 
                    'Профиль сотрудника'" 
            slot="title"
        />

        <section slot="under-title" class="gz-address-info-card__section">
            <StaffMemberCard :data="dataComputed"/>
        </section>

        <section slot="above-content" class="gz-tabs gz-tabs__section">
            <router-link 
                :to="`/admin/staff/${$route.params.id}/checkups`" 
                class="gz-tabs__item"
            >{{ $route.params.id === $store.getters['authUserId'] ? 
                'Список ваших проверок' : 
                'Список проверок сотрудника' }}
            </router-link>

            <router-link 
                v-if="isAdmin() || $route.params.id === $store.getters['authUserId']"
                :to="`/admin/staff/${$route.params.id}/info`" 
                class="gz-tabs__item"
            >{{ $route.params.id === $store.getters['authUserId'] ? 
                'Данные профиля' : 
                'Данные сотрудника' }}</router-link>
        </section>

        <section slot="content">
            <router-view></router-view>
        </section>        
    </gz-auth-view-template>
</template>

<script>
import StaffMemberCard from '@/components/custom/admin/views/staff/StaffMemberCard'

export default {
    name: 'StaffSingle',

    components: {
        StaffMemberCard
    },
    data() {
        return {
            data: {}
        }
    },
    computed: {
        dataComputed() {
            return this.data
        }
    },
    mounted() {
        this.$store.dispatch('staffUserviewGet', this.$route.params.id)
            .then(() => {
                this.data = this.$store.getters['staffUserview']
            })
    },
    watch: {
    //Обновляет юзера при переходе из authmenu
        $route() {
            this.$store.dispatch('staffUserviewGet', this.$route.params.id)
            .then(() => {
                this.data = this.$store.getters['staffUserview']
            })
        }
    }
}
</script>